import { render, staticRenderFns } from "./stationed_account_extract_detail.vue?vue&type=template&id=634d44c9&scoped=true"
import script from "./stationed_account_extract_detail.vue?vue&type=script&lang=js"
export * from "./stationed_account_extract_detail.vue?vue&type=script&lang=js"
import style0 from "./stationed_account_extract_detail.vue?vue&type=style&index=0&id=634d44c9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634d44c9",
  null
  
)

export default component.exports